import { useEffect } from 'react';

export const useHideHelpshift = () => {
  useEffect(() => {
    if (!window?.Helpshift) return;
    window.Helpshift('hide');
    return () => {
      window.Helpshift('show');
    };
  }, []);
};
